// status.ts — единое отображение RunStatus в визуальные токены дизайн-системы
// (классы .done/.prog/.aband/.pend из theme.css, перенесённые 1:1 из мокапа).
// Бэкенд хранит сырой статус (null = run'а нет); цвет/глиф/подпись — забота фронта.

import type { RunStatus } from '../api/contract';

export type StatusKey = 'done' | 'prog' | 'aband' | 'pend';

/** RunStatus | null → ключ визуального токена. pending и «нет run'а» → pend. */
export function statusKey(status: RunStatus | null): StatusKey {
  switch (status) {
    case 'completed':
      return 'done';
    case 'in_progress':
      return 'prog';
    case 'abandoned':
      return 'aband';
    default:
      return 'pend';
  }
}

/** Глиф для ячейки сетки «Неделя». */
export const CELL_GLYPH: Record<StatusKey, string> = {
  done: '✓',
  prog: '…',
  aband: '✕',
  pend: '·',
};

/** Короткая подпись статуса для пилюли на экране «Сегодня». */
export const STATUS_LABEL: Record<StatusKey, string> = {
  done: 'сдан',
  prog: 'заполняет',
  aband: 'не сдан',
  pend: 'не начат',
};
